import MuiCancel from '@mui/icons-material/Cancel';
import MuiCheckCircle from '@mui/icons-material/CheckCircle';
import styled, { css } from 'styled-components';
import { palette } from '../../design-system/colors';

export const CheckCircle = styled(MuiCheckCircle)`
    color: ${palette.evergreen.aspargus};
    ${(props) =>
        props.inactive &&
        css`
            color: rgba(palette.graphite.heavyMetal, 0.1);
        `};

    ${(props) =>
        props.big
            ? css`
                  transform: scale(1.5);
              `
            : css`
                  transform: scale(0.75);
              `}
`;

export const CancelCircle = styled(MuiCancel)`
    color: ${palette.vibrant.red};
    ${(props) =>
        props.big
            ? css`
                  transform: scale(1.5);
              `
            : css`
                  transform: scale(0.75);
              `}
`;
